var map = {
	"./1613408160646 (1).png": 5409,
	"./404.gif": 3764,
	"./American_Express_logo.svg": 1741,
	"./IconActive/01-fullbatt.svg": 9261,
	"./IconActive/02-halfbatt.svg": 7418,
	"./IconActive/03-halfempty.svg": 6290,
	"./IconActive/04-fullempty.svg": 3789,
	"./IconActive/active.svg": 340,
	"./IconActive/add.svg": 3192,
	"./IconActive/add2.svg": 7569,
	"./IconActive/battery.svg": 4080,
	"./IconActive/batteryfill.gif": 2346,
	"./IconActive/inactive.svg": 697,
	"./IconActive/inactivedum.svg": 2886,
	"./IconActive/nodevice.png": 7691,
	"./IconActive/pay.svg": 4790,
	"./LoadingAnimation.gif": 4469,
	"./Mastercard-logo.svg": 8058,
	"./Visa_logo.svg": 407,
	"./advance.png": 5163,
	"./advanceImgone.svg": 7846,
	"./advanceImgthree.svg": 3210,
	"./advanceImgtwo.svg": 365,
	"./amazon-appstore.svg": 1926,
	"./android.png": 7463,
	"./androidHomeQR.png": 202,
	"./androidQR.png": 5326,
	"./app-store.svg": 7179,
	"./app_store.svg": 5370,
	"./arrowUp.svg": 7042,
	"./badge-dark.png": 1970,
	"./banneSSSS - Copy.png": 7414,
	"./banneSSSS.png": 4956,
	"./banner.png": 2962,
	"./batteryStatus.svg": 6045,
	"./bell.svg": 2244,
	"./bell2.svg": 4924,
	"./board1.svg": 5608,
	"./board2.svg": 9479,
	"./board3.svg": 4775,
	"./board4.svg": 4879,
	"./coin.png": 5691,
	"./coinblur.png": 7630,
	"./company.png": 993,
	"./create-0.png": 2963,
	"./create-1.png": 64,
	"./create-2.png": 4681,
	"./endnow.gif": 7836,
	"./error1.png": 3681,
	"./error2.png": 668,
	"./error3.png": 3088,
	"./error4.png": 4748,
	"./error5.png": 4428,
	"./error6.png": 9130,
	"./error7.png": 1871,
	"./exchange.svg": 9712,
	"./extend.gif": 9227,
	"./fifthImage.png": 101,
	"./filter.svg": 8638,
	"./firstImage.png": 8781,
	"./firstImagee.png": 6971,
	"./fourthImage.png": 4275,
	"./fourthImageee.png": 8575,
	"./fourthImageff.png": 5125,
	"./google-play.svg": 1678,
	"./google.svg": 4966,
	"./google_play.svg": 9252,
	"./google_play_home.svg": 6443,
	"./ids.svg": 3587,
	"./invoice-icon.svg": 8890,
	"./jmlogo.png": 3358,
	"./leftArrow.png": 2376,
	"./listevents.gif": 4805,
	"./loading.gif": 6053,
	"./loading2.gif": 8654,
	"./lock.svg": 8130,
	"./loginBackground.png": 9762,
	"./loginImg.jpg": 3703,
	"./logo.png": 6949,
	"./main.png": 763,
	"./mobilecss/style.css": 3548,
	"./office365.svg": 2194,
	"./one1.png": 8488,
	"./part.svg": 6758,
	"./partner.svg": 7573,
	"./philips1.jpg": 1720,
	"./philips2.jpg": 3659,
	"./philips3.jpg": 4487,
	"./playstore.png": 740,
	"./powered_by_stripe.svg": 5286,
	"./printer.png": 3153,
	"./qw.gif": 8872,
	"./receipt.svg": 5681,
	"./rightArrow.png": 1059,
	"./rupay.png": 3751,
	"./secImae.png": 7075,
	"./secImage.png": 3943,
	"./seccoin.png": 949,
	"./security.png": 9920,
	"./securityImg.png": 6649,
	"./securityThird.png": 6607,
	"./settings-menu.png": 72,
	"./supportEmail.png": 9789,
	"./tab1.png": 2999,
	"./tab2.png": 9898,
	"./tab3.png": 7559,
	"./tab4.png": 9679,
	"./tab5.png": 7529,
	"./teamup.svg": 4183,
	"./teamup1.png": 5397,
	"./teamup2.png": 3363,
	"./teamup3.png": 6874,
	"./testimonialOne.png": 9970,
	"./testimonialfour.png": 1711,
	"./testimonialthree.png": 9482,
	"./testimonialtwo.png": 3463,
	"./thirdImage.png": 2498,
	"./tick.png": 1391,
	"./two1.png": 811,
	"./usenowdemo.gif": 5740,
	"./verified.png": 8271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;